const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const StudioProductStatusQueryURL = {
    GetStudioProductStatuses: Backofficebff + '/v1/ProductStatus/get-product-status',
};
